import React from 'react';
import { ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { CtaButton } from './ui/CtaButton';
import { BONUS_VALUE, CHECKOUT_URL, PACK_IMAGE, PRICE, PRODUCT_NAME } from '../data/content';
export function OfferSection() {
  return <section id="oferta" aria-labelledby="oferta-titulo" className="scroll-mt-2 border-y-4 border-brand-yellow bg-brand-night" data-id="element-115" data-mp="ddvgdgeskhf3">
      <div className="mx-auto max-w-xl px-3 py-5 text-center sm:px-5" data-id="element-116" data-mp="icowlglgqmiy">
        <p className="font-display text-[0.62rem] font-bold uppercase tracking-[0.14em] text-brand-yellow" data-id="element-117" data-mp="mds8js0e3yew">
          Oferta especial — Sistema completo 6 en 1
        </p>
        <h2 id="oferta-titulo" className="mt-1.5 font-display text-base font-extrabold leading-tight text-white sm:text-xl" data-id="element-118" data-mp="wcr6afjma9n4">
          Comienza hoy y organiza tus clases con una ruta paso a paso.
        </h2>

        <Reveal className="mt-3 overflow-hidden rounded-xl border-4 border-dashed border-brand-yellow bg-white text-brand-night" data-id="element-119" data-mp="2y55olfq2pg42">
          <a href={CHECKOUT_URL} target="_blank" rel="noopener noreferrer" className="block" data-id="element-120" data-mp="12plckvyk3hav">
            <img src={PACK_IMAGE} alt={`${PRODUCT_NAME}: 6 tomos digitales y 5 bonos incluidos`} className="block w-full" data-id="element-121" data-mp="xup64qskore8" />
          </a>
          <div className="p-3" data-id="element-122" data-mp="oxyd6n9bhsnv">
            <p className="font-display text-[0.8rem] font-black uppercase leading-tight text-brand-blue sm:text-sm" data-id="element-123" data-mp="1lme86yv74u8d">
              {PRODUCT_NAME}
            </p>
            <p className="mt-0.5 font-num text-lg uppercase tracking-wide" data-id="element-124" data-mp="1go2uue5p01le">
              6 Tomos + 5 Bonos
            </p>
            <p className="text-[0.75rem] text-brand-night/75" data-id="element-125" data-mp="1cnizng4oj81w">
              🎁 Bonos valorados en{' '}
              <span className="font-semibold text-brand-red line-through" data-id="element-126" data-mp="16j7ckic0t7v">
                {BONUS_VALUE}
              </span>
            </p>

            <p className="mt-1.5 inline-block rounded bg-brand-red px-2.5 py-0.5 font-display text-[0.62rem] font-black uppercase tracking-wide text-white" data-id="element-127" data-mp="3sbspjq03436x">
              🔥 Oferta especial
            </p>

            <p className="mt-1 font-num text-5xl leading-none text-brand-green sm:text-6xl" data-id="element-128" data-mp="2mdje1wgtm0h">
              Hoy: {PRICE}
            </p>
            <p className="mt-1 text-[0.7rem] font-medium text-brand-night/75" data-id="element-129" data-mp="3kvnsxij408k5">
              Pago único • Sin mensualidades • Acceso Digital
            </p>

            <CtaButton href={CHECKOUT_URL} external size="lg" className="mt-3" data-id="element-130" data-mp="3b2gnxysa6ukl">
              🚀 Sí, quiero el sistema completo por {PRICE}
            </CtaButton>

            <p className="mt-2 flex flex-wrap items-center justify-center gap-x-3 gap-y-1 text-[0.68rem] font-medium text-brand-night/75" data-id="element-131" data-mp="315luhuav7kd6">
              <span className="flex items-center gap-1" data-id="element-132" data-mp="3656tg4q1bspw">
                <ZapIcon size={12} className="text-brand-orange" data-id="element-133" data-mp="2s4w1szgwia3o" />
                Acceso Inmediato
              </span>
              <span className="text-brand-night/40" data-id="element-134" data-mp="2x409flo6fzrw">•</span>
              <span className="flex items-center gap-1" data-id="element-135" data-mp="2x5jpbb5x88t5">
                <ShieldCheckIcon size={12} className="text-brand-green" data-id="element-136" data-mp="2diqahmmhz6y4" />
                Garantía de 7 Días
              </span>
            </p>
          </div>
        </Reveal>
      </div>
    </section>;
}